import { render, staticRenderFns } from "./chat-unified.vue?vue&type=template&id=4481f1f0&scoped=true"
import script from "./chat-unified.vue?vue&type=script&lang=js"
export * from "./chat-unified.vue?vue&type=script&lang=js"
import style0 from "./chat-unified.vue?vue&type=style&index=0&id=4481f1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481f1f0",
  null
  
)

export default component.exports